import React from 'react';
import { Container, Paper, Typography } from '@mui/material';
import RolePermissionManager from '../../components/admin/RolePermissionManager';

const RolePermissionPage: React.FC = () => {
  return (
    <Container maxWidth='xl'>
      <Paper sx={{ p: 3, mt: 3 }}>
        <Typography variant='h4' gutterBottom>
          Role & Permission Management
        </Typography>
        <RolePermissionManager />
      </Paper>
    </Container>
  );
};

export default RolePermissionPage;
